import Dashboard from "../../../app/dashboard";
import Users from "../../../app/users";
import Beacons from "../../../app/beacons";
import Statistics from "../../../app/statistics";
import Institutions from "../../../app/institutions";
import InstitutionForm from "../../../app/institutions/components/Form";
import Protocols from "../../../app/protocols";
import Settings from "../../../app/settings";

export const userRoutes = [
  {
    category: "Dashboard",
    path: "/dashboard",
    icon: "ph-duotone ph-house-line",
    title: "Dashboard",
    component: <Dashboard />,
    showInSidebar: true,
  },
  {
    category: "Institutions",
    path: "/institutions",
    icon: "ph-duotone ph-buildings",
    title: "Institutions",
    component: <Institutions />,
    showInSidebar: true,
  },
  {
    path: "/institutions/create",
    component: <InstitutionForm />,
  },
  {
    path: "/institutions/:institutionId",
    component: <InstitutionForm />,
  },
  {
    category: "Users",
    path: "/users",
    icon: "ph-duotone ph-users",
    title: "Users",
    component: <Users />,
    showInSidebar: true,
  },
  // {
  //   category: "Beacons",
  //   path: "/beacons",
  //   icon: "ph-duotone ph-target",
  //   title: "Beacons",
  //   component: <Beacons />,
  //   showInSidebar: true,
  // },
  {
    category: "Protocols",
    path: "/protocols",
    icon: "ph-duotone ph-clipboard-text",
    title: "Protocols",
    component: <Protocols />,
    showInSidebar: true,
  },
  {
    category: "Statistics",
    path: "/statistics",
    icon: "ph-duotone ph-chart-line-up",
    title: "Statistics",
    component: <Statistics />,
    showInSidebar: true,
  },
];
